import { CheckLight } from 'emerald-icons/dist/CheckLight';
import React, { forwardRef } from 'react';
import { visuallyHiddenMixin } from '../../styles/mixins';
import { CompactIconStyled, LabeledIconStyled } from '../Counter';
import { CheckmarkBubble, checkmarkCss, CompactFrameStyle, SidePanelFrameStyled } from './LabeledIconChecked.styles';

export const LabeledIconChecked = forwardRef(({
    icon,
    label,
    inputId,
    compact = false,
    ...otherProps
}, ref) => {

    if (compact) {

        return (
            <CompactFrameStyle
                {...otherProps}
            >
                <input
                    css={visuallyHiddenMixin}
                    id={inputId}
                    ref={ref}
                    type='checkbox'
                />
                <CompactIconStyled
                    forwardedAs='label'
                    htmlFor={inputId}
                    icon={icon}
                    label={label}
                />
            </CompactFrameStyle>
        );
    }

    return (
        <SidePanelFrameStyled
            middle={(
                <CheckmarkBubble>
                    <CheckLight css={checkmarkCss} />
                </CheckmarkBubble>
            )}
            {...otherProps}
        >
            <input
                css={visuallyHiddenMixin}
                id={inputId}
                ref={ref}
                type='checkbox'
            />
            <LabeledIconStyled
                forwardedAs='label'
                htmlFor={inputId}
                icon={icon}
                label={label}
            />
        </SidePanelFrameStyled>
    );
});

LabeledIconChecked.displayName = 'LabeledIconChecked';
